import Label from "./label.component";
export default Label